import { isOnboardingAccountSetupComplete } from 'components/onboarding-account-setup/onboarding-account-setup.selectors';
import { usePatientPortalContext } from 'contexts/patient-portal-provider.context';
import { usePostFtux } from 'hooks/mutations/use-post-ftux/use-post-ftux.hook';
import { getLeagueSdkErrorCode } from 'utils/parse-league-sdk-error';
import { useGetUserProfile } from '../queries/use-get-user-profile.hook';

export const useOnboardingCompletion = () => {
  const { data, isLoading, error } = useGetUserProfile();
  const { systemId } = usePatientPortalContext();

  const {
    featureHighlightsComplete,
    error: ftuxError,
    isLoading: ftuxIsLoading,
    markFeatureHighlightsComplete,
  } = usePostFtux();

  const errorCode = error ? getLeagueSdkErrorCode(error) : undefined;
  const isNewUser = errorCode === 404;

  return {
    accountSetupComplete: isOnboardingAccountSetupComplete(data, systemId),
    featureHighlightsComplete: !!featureHighlightsComplete,
    markFeatureHighlightsComplete,
    isLoading: isLoading || ftuxIsLoading,
    error: isNewUser ? null : error ?? ftuxError,
  };
};
